{
  "PAGINATION_FOOTER": {
    "SHOWING": "Showing {startItem} - {endItem} of {totalItems} items",
    "CURRENT_PAGE_INFO": "{currentPage} of {totalPages} pages"
  },
  "COMBOBOX": {
    "PLACEHOLDER": "Select an option...",
    "EMPTY_SEARCH_RESULTS": "No items found for the search term `{searchTerm}`",
    "EMPTY_STATE": "Aucun résultat trouvé.",
    "SEARCH_PLACEHOLDER": "Search...",
    "MORE": "+{count} more"
  },
  "DROPDOWN_MENU": {
    "SEARCH_PLACEHOLDER": "Search...",
    "EMPTY_STATE": "Aucun résultat trouvé.",
    "SEARCHING": "Recherche en cours..."
  },
  "DIALOG": {
    "BUTTONS": {
      "CANCEL": "Annuler",
      "CONFIRM": "Confirmer"
    }
  },
  "PHONE_INPUT": {
    "SEARCH_PLACEHOLDER": "Search country",
    "ERROR": "Phone number should be empty or in E.164 format",
    "DIAL_CODE_ERROR": "Veuillez sélectionner un code d'appel dans la liste"
  },
  "THUMBNAIL": {
    "AUTHOR": {
      "NOT_AVAILABLE": "L'auteur n'est pas disponible"
    }
  },
  "BREADCRUMB": {
    "ARIA_LABEL": "Breadcrumb"
  },
  "SWITCH": {
    "TOGGLE": "Toggle switch"
  },
  "LABEL": {
    "TAG_BUTTON": "tag"
  },
  "FEATURE_SPOTLIGHT": {
    "LEARN_MORE": "En savoir plus",
    "WATCH_VIDEO": "Watch video"
  },
  "COLOR_GRID": {
    "SHOW_COLORS": "Afficher les couleurs",
    "HIDE_COLORS": "Masquer les couleurs"
  },
  "DURATION_INPUT": {
    "MINUTES": "Minutes",
    "HOURS": "Heures",
    "DAYS": "Jours",
    "PLACEHOLDER": "Saisir une durée"
  }
}
